const groupsActionTypes = {
  FETCH_GROUPS_REQUEST: 'FETCH_GROUPS_REQUEST',
  FETCH_GROUP_DETAILS_REQUEST:"FETCH_GROUP_DETAILS_REQUEST",
  FETCH_GROUPS_REQUEST_SUCCESS: 'FETCH_GROUPS_REQUEST_SUCCESS',
  FETCH_GROUPS_REQUEST_FAILURE: 'FETCH_GROUPS_REQUEST_FAILURE',
  GROUPS_SET_DATA: 'GROUPS_SET_DATA',
  CREATE_GROUP_REQUEST: 'CREATE_GROUP_REQUEST',
  CREATE_GROUP_SUCCESS: 'CREATE_GROUP_SUCCESS',
  CREATE_GROUP_FAILURE: 'CREATE_GROUP_FAILURE',
  REMOVE_GROUPS_POPUP: 'REMOVE_GROUPS_POPUP',
  FETCH_GROUP_DETAILS_SUCCESS: 'FETCH_GROUP_DETAILS_SUCCESS',
  GROUP_SET_ERROR: 'GROUP_SET_ERROR',
  GROUP_DETAILS_SET_ERROR:'GROUP_DETAILS_SET_ERROR',
  FETCH_GROUP_DETAILS_FAILURE: 'FETCH_GROUP_DETAILS_FAILURE',
  GROUP_DELETE_SUCCESS: 'GROUP_DELETE_SUCCESS',
  GROUP_DELETE_FAILURE: 'GROUP_DELETE_FAILURE',
  REMOVE_GROUP_DELETE_DATA: 'REMOVE_GROUP_DELETE_DATA',

  FETCH_GROUP_NAMES_SUCCESS: 'FETCH_GROUP_NAMES_SUCCESS',
  FETCH_GROUP_NAMES_FAILURE: 'FETCH_GROUP_NAMES_FAILURE',

  ASSOCIATE_BULK_USERS_SUCCESS: 'ASSOCIATE_BULK_USERS_SUCCESS',
  ASSOCIATE_BULK_USERS_FAILURE: 'ASSOCIATE_BULK_USERS_FAILURE',
  REMOVE_BULK_USERS_SUCCESS_MESSAGE: 'REMOVE_BULK_USERS_SUCCESS_MESSAGE',
  ASSOCIATE_BULK_USERS_FAILURE_MESSAGE: 'ASSOCIATE_BULK_USERS_FAILURE_MESSAGE',
  UPDATE_GROUP_SUCCESS: 'UPDATE_GROUP_SUCCESS',
  UPDATE_GROUP_FAILURE: 'UPDATE_GROUP_FAILURE',
  REMOVE_GROUP_UPDATE_DATA: 'REMOVE_GROUP_UPDATE_DATA',
  GET_GROUP_BACKBTN_SUCCESS: 'GET_GROUP_BACKBTN_SUCCESS',
  GET_GROUP_BACKBTN_FAILURE: 'GET_GROUP_BACKBTN_FAILURE',
};

export default groupsActionTypes;
